<template>
  <td v-if="renderCell" :class="className" 
    colspan="1" 
    :data-grid-col-index="columnIndex"  
    role="gridcell">
    <div class="flex flex-wrap">
      <span
        v-for="tag in getNestedValue(field, dataItem)" :key="tag"
        class="rounded-full mr-1 mb-1 pl-1 pr-1 bg-primary-50 dark:bg-darkblue text-primary-800 dark:text-primary-600 border-2 tag-cell"
      >
      {{ tag }}
      </span>
    </div>
  </td>
  <td
    v-else-if="renderArrow"
    key="'g' + columnIndex"
    :class="'k-group-cell'"
    colspan="1" 
    :data-grid-col-index="columnIndex"  
    role="gridcell"
  ></td>
  <td
    v-else-if="columnIndex <= level"
    key='g-colspan'
    :colSpan="columnsCount - columnIndex"
    :data-grid-col-index="columnIndex"  
    role="gridcell"
  >
    <p class='k-reset'>
      <a
        @click="onClick"
        tabIndex='-1'
        href='#'
        :class="expanded ? 'k-i-collapse k-icon' : 'k-i-expand k-icon'"
      />
      {{ dataItem[field] }}
    </p>
  </td>
</template>
<script>
import moment from 'moment'

function nestedValue (fieldName, dataItem) {
  const path = fieldName.split('.')
  let data = dataItem
  path.forEach((p) => {
    data = data ? data[p] : undefined
  })

  return data
}

export default {
  emits: {
    click: null
  },
  props: {
    field: String,
    dataItem: Object,
    format: String,
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String
  },
  data () {
    return {
      tags: ['tag1']
    }
  },
  computed: {
    renderArrow () {
      var returnValue =
        this.columnIndex === undefined ||
        this.level === undefined ||
        this.columnIndex < this.level ||
        this.columnsCount === undefined ||
        this.rowType !== 'groupHeader' ||
        this.dataItem[this.field] === undefined
      return returnValue && this.dataItem[this.field]
    },
    renderCell () {
      return this.field !== undefined && this.rowType !== 'groupHeader'
    },
    tagsValues () {
      // console.log(this.getNestedValue(this.field, this.dataItem))
      return this.getNestedValue(this.field, this.dataItem)
    }
  },
  methods: {
    onClick (e) {
      // @ts-ignore
      this.$emit('click', e, this.dataItem, this.expanded)
    },
    formatTags: function (strDate) {
      if (!this.isEmptyArray(strDate)) return ' - '
      return moment(strDate).format('DD-MM-yyyy HH:mm')
    },
    isEmptyArray: function (arrayTags) {
      if (arrayTags === undefined || arrayTags === null || arrayTags.length === 0) return true
      return false
    },
    getNestedValue: nestedValue
  }
}
</script>

<style scoped>
.bg-success-p{
  background-color: black;
}
.tag-cell{
  border-color: var(--Tag-border-)!important;
}
</style>
